module.exports = __webpack_public_path__ + "static/media/Avatars_Other-07.e4594d01.png";